// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  worldId: __t.u64().name("world_id"),
  kind: __t.string(),
  subject: __t.u64(),
  inputsHash: __t.byteArray().name("inputs_hash"),
  priority: __t.u8(),
  status: __t.u8(),
  worker: __t.option(__t.identity()),
  leaseUntil: __t.option(__t.timestamp()).name("lease_until"),
  attempts: __t.u8(),
  createdAt: __t.timestamp().name("created_at"),
  deliveredAt: __t.option(__t.timestamp()).name("delivered_at"),
  note: __t.string(),
  inputs: __t.byteArray(),
  storyteller: __t.u8(),
});
